<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content" style="width:650px">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">客戶申請拒絕行銷</h3>
        </div>
        <div class="modal-body">
          <div class="warning">
            <div>
              ※若客戶已申請「拒絕國泰人壽行銷」，表示其不接受公司發送任何行銷活動訊息(包含簡訊、Email、郵寄及非經手或服務業務員行銷)，敬請注意。
            </div>
            <br>
            <!-- <div>
              ※若客戶已申請「拒絕共同行銷」，表示不同意其個資跨子公司進行行銷或蒐集、處理或利用，敬請注意。
            </div> 
            <br> -->
            <div>
              <span style="color:red;">※如客戶欲申請拒絕行銷，請客戶本人臨櫃至服務中心或是進線0800進行辦理。</span>
            </div>  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'RejectMarketingModal',
    props: {
    open: {
      type: Boolean,
      default: false
    }
  }
}
</script>
